define(function (require) {
	const Marionette = require('backbone.marionette');
	const SigninItemView = require('./v_itv_login_signin');
	const tpl = require('./templates/t_lov_login_signin.hbs');
	const ModalRegion = require('civicsUtils/modal_region');

	return Marionette.LayoutView.extend({
		template: tpl,
		regions: {
			SigninItemViewRegion: '.user-login',
			modalRegion:{
				regionClass: ModalRegion,
				selector:'body .rhythm-modals'
			},
		},
		className: 'user-login-view',
		childEvents:{
			'activationFailed':function(){this.triggerMethod('activationFailed2');},
			'enforcedMFA': function(){this.triggerMethod('mfa:setupRequired');},
		},
		initialize: function (options) {
			this.config = options.config;
		},
		onRender: function () {
		},
		onShow: function () {
			var signinItemView = new SigninItemView({
				config: this.config,
				modalRegion:this.modalRegion
			});
			this.SigninItemViewRegion.show(signinItemView);
		},
		templateHelpers: function () {
			return {
				Title: this.config.Title,
				TitleOn: this.config.TitleOn,
				notActivated: ()=>{
					return (this.config.urlParms && this.config.urlParms.activationCode);
				}
			};
		}
	});
});
